import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ClearanceItemService } from './clearance-item.service';
import { ItemHistory, ClearanceItem } from './clearance-item.model';
import { GlobalErrorHandler } from '../shared/core/error-handler';

@Component({    
    moduleId: module.id.toString(),
    selector: 'clearance-item-history',
    template: require('./clearance-item-history.component.html'),
})

export class ClearanceItemHistoryComponent implements OnInit {

    onHistoryRetrieved(history: ItemHistory[]): any {
        // console.log('history:' + JSON.stringify(history));
        if (history.length == 0) {
            this.historyLabel = 'No history was found';// for item: " + this.item.name;
        }
        this.history = history;
    }

    constructor(private route: ActivatedRoute,
        private router: Router,
        private itemService: ClearanceItemService,
        private _location: Location,
        private _errorHandler: GlobalErrorHandler                        
    ) {
        itemService.CurrrentClearanceItem.subscribe(i => {
            this.item = i;
        });
    }

    itemId: string;
    history: ItemHistory[] = [];
    item: ClearanceItem;
    historyLabel: string = '';

    ngOnInit(): void {


        // // Read the clearance Id from the route parameter
        this.route.params.subscribe(
            params => {
                let id = params['ciId'];
                this.itemId = id;
                if (id) {
                    this.getHistory(id);
                }
            }
        );
    }

    closeHistory() {
        this._location.back();
    }
    getHistory(id: string): void {
        // this.showSpinner = true;
        this.itemService.getHistory(id)
            .subscribe
            (
            (data) => {
                this.onHistoryRetrieved(data);
                //this.showSpinner = false;
            },
            // (error: any) => {
            //     //console.error('get clearance item(...):' + error);
            //     // this.errorMessage = <any>error;
            //     // this.showSpinner = false;
            //     this._errorHandler.processError(error);                
            // }
            );

    }

}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/clearance-item/clearance-item-history.component.ts